/**
 * Mapeo de columnas para Excel de ASN
 * 
 * Si se necesita cambiar el orden de las columnas en el Excel,
 * solo hay que modificar los índices aquí.
 */

// ===================================
// Hoja 1: Cabecera del ASN
// ===================================
export const ASN_CABECERA_COLUMNS = {
  CABECERA_NUM: 0,
  FECHA_ESTIMADA: 1,
  TIPO_DOCUMENTO: 2,
  TIPO_RECEPCION: 3,
  REFERENCIA_EXTERNA: 4,
  ALMACEN: 5,
  CLIENTE: 6,
  OBSERVACIONES: 7
};

// ===================================
// Hoja 2: Items del ASN
// ===================================
export const ASN_ITEMS_COLUMNS = {
  CABECERA_NUM: 0,
  SKU: 1,
  CANTIDAD_ESPERADA: 2,
  // Atributos esperados: solo se cargan si el cliente tiene request_asn_attributes
  LOTE: 3,
  FECHA_EXPIRACION: 4,
  SERIE: 5,
  CALIDAD: 6,
  DESCRIPTIVO_1: 7, // Columna H - Opcional según configuración del sistema
  DESCRIPTIVO_2: 8, // Columna I - Opcional según configuración del sistema
  DESCRIPTIVO_3: 9  // Columna J - Opcional según configuración del sistema
};

// ===================================
// Nombres legibles para headers
// ===================================
export const ASN_CABECERA_HEADERS = {
  [ASN_CABECERA_COLUMNS.CABECERA_NUM]: 'Cabecera N°*',
  [ASN_CABECERA_COLUMNS.FECHA_ESTIMADA]: 'Fecha estimada de arribo* (YYYY-MM-DD)',
  [ASN_CABECERA_COLUMNS.TIPO_DOCUMENTO]: 'Tipo de Documento*',
  [ASN_CABECERA_COLUMNS.TIPO_RECEPCION]: 'Tipo de Recepción',
  [ASN_CABECERA_COLUMNS.REFERENCIA_EXTERNA]: 'Referencia Externa',
  [ASN_CABECERA_COLUMNS.ALMACEN]: 'Almacén*',
  [ASN_CABECERA_COLUMNS.CLIENTE]: 'Cliente*',
  [ASN_CABECERA_COLUMNS.OBSERVACIONES]: 'Observaciones'
};

export const ASN_ITEMS_HEADERS = {
  [ASN_ITEMS_COLUMNS.CABECERA_NUM]: 'Cabecera N°*',
  [ASN_ITEMS_COLUMNS.SKU]: 'SKU*',
  [ASN_ITEMS_COLUMNS.CANTIDAD_ESPERADA]: 'Cantidad esperada*',
  [ASN_ITEMS_COLUMNS.LOTE]: 'Lote',
  [ASN_ITEMS_COLUMNS.FECHA_EXPIRACION]: 'Fecha de Expiración (YYYY-MM-DD)',
  [ASN_ITEMS_COLUMNS.SERIE]: 'Serie',
  [ASN_ITEMS_COLUMNS.CALIDAD]: 'Calidad'
};

// ===================================
// ÓRDENES DE ENVÍO (SHIPMENT ORDERS)
// ===================================

// Hoja 1: Cabecera de Órdenes de Envío
export const SHIPMENT_ORDER_CABECERA_COLUMNS = {
  CABECERA_NUM: 0,
  FECHA: 1,
  FECHA_ESTIMADA_ENTREGA: 2,
  TIPO_DOCUMENTO: 3,
  REFERENCIA_EXTERNA: 4,
  ALMACEN: 5,
  CLIENTE: 6,
  CANAL_VENTA: 7,
  PUNTO_ENTREGA: 8,
  DESTINATARIO: 9,
  DIRECCION: 10,
  REFERENCIA_DIRECCION: 11,
  LOCALIDAD: 12,
  CODIGO_POSTAL: 13,
  PROVINCIA: 14,
  TELEFONO: 15,
  EMAIL: 16
};

// Hoja 2: Items de Órdenes de Envío
// NOTA sobre DESCRIPTIVOS: Siempre están en las columnas I, J, K (índices 8, 9, 10) del Excel.
// Si un descriptivo NO está habilitado en el sistema, el backend genera la columna con header vacío "" y la oculta.
// En el frontend, siempre se leen estos índices pero solo se muestran si isAliasEnabled(descriptivo_X).
// Los nombres reales de los descriptivos se obtienen dinámicamente con getAliasName() del AliasMixin.
export const SHIPMENT_ORDER_ITEMS_COLUMNS = {
  CABECERA_NUM: 0,
  SKU: 1,
  CANTIDAD: 2,
  ESTADO_PRODUCTO: 3,
  LOTE: 4,
  SERIE: 5,
  FECHA_EXPIRACION: 6,
  CALIDAD: 7,
  DESCRIPTIVO_1: 8,  // Columna I - Opcional según configuración del sistema
  DESCRIPTIVO_2: 9,  // Columna J - Opcional según configuración del sistema
  DESCRIPTIVO_3: 10  // Columna K - Opcional según configuración del sistema
};

// Nombres legibles para headers de Órdenes de Envío
export const SHIPMENT_ORDER_CABECERA_HEADERS = {
  [SHIPMENT_ORDER_CABECERA_COLUMNS.CABECERA_NUM]: 'Cabecera N°*',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.FECHA]: 'Fecha* (YYYY-MM-DD)',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.FECHA_ESTIMADA_ENTREGA]: 'Fecha estimada de entrega (YYYY-MM-DD)',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.TIPO_DOCUMENTO]: 'Tipo de Documento*',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.REFERENCIA_EXTERNA]: 'Referencia Externa',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.ALMACEN]: 'Almacén*',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.CLIENTE]: 'Cliente*',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.CANAL_VENTA]: 'Canal de Venta',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.PUNTO_ENTREGA]: 'Punto de Entrega',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.DESTINATARIO]: 'Destinatario*',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.DIRECCION]: 'Dirección*',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.REFERENCIA_DIRECCION]: 'Referencia de Dirección',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.LOCALIDAD]: 'Localidad*',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.CODIGO_POSTAL]: 'Código Postal',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.PROVINCIA]: 'Provincia*',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.TELEFONO]: 'Teléfono',
  [SHIPMENT_ORDER_CABECERA_COLUMNS.EMAIL]: 'Email'
};

export const SHIPMENT_ORDER_ITEMS_HEADERS = {
  [SHIPMENT_ORDER_ITEMS_COLUMNS.CABECERA_NUM]: 'Cabecera N°*',
  [SHIPMENT_ORDER_ITEMS_COLUMNS.SKU]: 'SKU*',
  [SHIPMENT_ORDER_ITEMS_COLUMNS.CANTIDAD]: 'Cantidad*',
  [SHIPMENT_ORDER_ITEMS_COLUMNS.ESTADO_PRODUCTO]: 'Estado de Producto',
  [SHIPMENT_ORDER_ITEMS_COLUMNS.LOTE]: 'Lote',
  [SHIPMENT_ORDER_ITEMS_COLUMNS.SERIE]: 'Serie',
  [SHIPMENT_ORDER_ITEMS_COLUMNS.FECHA_EXPIRACION]: 'Fecha de Expiración',
  [SHIPMENT_ORDER_ITEMS_COLUMNS.CALIDAD]: 'Calidad',
  [SHIPMENT_ORDER_ITEMS_COLUMNS.DESCRIPTIVO_1]: 'Descriptivo 1',
  [SHIPMENT_ORDER_ITEMS_COLUMNS.DESCRIPTIVO_2]: 'Descriptivo 2',
  [SHIPMENT_ORDER_ITEMS_COLUMNS.DESCRIPTIVO_3]: 'Descriptivo 3'
};

// ===================================
// PRODUCTOS (PRODUCTS)
// ===================================

// Columnas de Productos
// NOTA sobre DESCRIPTIVOS: Las columnas O, P, Q (índices 14, 15, 16) son para controles de descriptivos.
// Si un descriptivo NO está habilitado, el backend genera la columna con header vacío "" y la oculta.
// En el frontend, siempre se leen estos índices pero solo se muestran si isAliasEnabled(descriptivo_X).
export const PRODUCT_COLUMNS = {
  SKU: 0,
  PRODUCTO: 1,
  CLIENTE_USERNAME: 2,
  CATEGORIA: 3,
  SUBCATEGORIA: 4,
  TIPO_PRODUCTO: 5,
  PROVEEDOR: 6,
  TIPO_ROTACION: 7,
  FRECUENCIA_ROTACION: 8,
  NO_APLICAR_LIMITE_PICKING: 9,
  USAR_ROTACION_ESTRICTO: 10,
  CONTROL_LOTES: 11,
  CONTROL_SERIE: 12,
  CONTROL_CALIDAD: 13,
  REQUIERE_FECHA_EXPIRACION: 14,
  CONTROL_DESCRIPTIVO_1: 15,  // Columna P - Opcional según configuración del sistema
  CONTROL_DESCRIPTIVO_2: 16,  // Columna Q - Opcional según configuración del sistema
  CONTROL_DESCRIPTIVO_3: 17,  // Columna R - Opcional según configuración del sistema
  UNIDAD_ALMACENAMIENTO: 18,
  UNIDAD_PESO: 19,
  UNIDAD_MEDIDA: 20,
  ALTO: 21,
  ANCHO: 22,
  LARGO: 23,
  VOLUMEN: 24,
  CODIGO_BARRA_UNIDAD: 25,
  CODIGO_BARRA_CAJA: 26,
  CANTIDAD_UNIDADES_CAJA: 27,
  CANTIDAD_UNIDADES_PALLET: 28,
  EXCLUIR_POLITICAS_REPOSICION: 29 // Columna AD - Opcional (SI/NO, vacio = NO). Version 3 de la plantilla
};

// Nombres legibles para headers de Productos
export const PRODUCT_HEADERS = {
  [PRODUCT_COLUMNS.SKU]: 'SKU*',
  [PRODUCT_COLUMNS.PRODUCTO]: 'Producto*',
  [PRODUCT_COLUMNS.CLIENTE_USERNAME]: 'Cliente Username*',
  [PRODUCT_COLUMNS.CATEGORIA]: 'Categoría*',
  [PRODUCT_COLUMNS.SUBCATEGORIA]: 'Subcategoría',
  [PRODUCT_COLUMNS.TIPO_PRODUCTO]: 'Tipo de Producto',
  [PRODUCT_COLUMNS.PROVEEDOR]: 'Proveedor',
  [PRODUCT_COLUMNS.TIPO_ROTACION]: 'Tipo de Rotación*',
  [PRODUCT_COLUMNS.FRECUENCIA_ROTACION]: 'Frecuencia de Rotación*',
  [PRODUCT_COLUMNS.NO_APLICAR_LIMITE_PICKING]: 'No aplicar límite de picking',
  [PRODUCT_COLUMNS.USAR_ROTACION_ESTRICTO]: 'Usar tipo de rotacion estricto',
  [PRODUCT_COLUMNS.CONTROL_LOTES]: 'Tiene Control por Lotes*',
  [PRODUCT_COLUMNS.CONTROL_SERIE]: 'Tiene Control por Serie*',
  [PRODUCT_COLUMNS.CONTROL_CALIDAD]: 'Tiene Control de Calidad*',
  [PRODUCT_COLUMNS.REQUIERE_FECHA_EXPIRACION]: 'Requiere Fecha de Expiración*',
  [PRODUCT_COLUMNS.CONTROL_DESCRIPTIVO_1]: 'Tiene Control por Descriptivo 1',
  [PRODUCT_COLUMNS.CONTROL_DESCRIPTIVO_2]: 'Tiene Control por Descriptivo 2',
  [PRODUCT_COLUMNS.CONTROL_DESCRIPTIVO_3]: 'Tiene Control por Descriptivo 3',
  [PRODUCT_COLUMNS.UNIDAD_ALMACENAMIENTO]: 'Unidad de Almacenamiento*',
  [PRODUCT_COLUMNS.UNIDAD_PESO]: 'Unidad de Peso',
  [PRODUCT_COLUMNS.UNIDAD_MEDIDA]: 'Unidad de Medida',
  [PRODUCT_COLUMNS.ALTO]: 'Alto',
  [PRODUCT_COLUMNS.ANCHO]: 'Ancho',
  [PRODUCT_COLUMNS.LARGO]: 'Largo',
  [PRODUCT_COLUMNS.VOLUMEN]: 'Volumen',
  [PRODUCT_COLUMNS.CODIGO_BARRA_UNIDAD]: 'Código de Barra Unidad*',
  [PRODUCT_COLUMNS.CODIGO_BARRA_CAJA]: 'Código de Barra Caja',
  [PRODUCT_COLUMNS.CANTIDAD_UNIDADES_CAJA]: 'Cantidad Unidades Caja',
  [PRODUCT_COLUMNS.CANTIDAD_UNIDADES_PALLET]: 'Cantidad Unidades Pallet*',
  [PRODUCT_COLUMNS.EXCLUIR_POLITICAS_REPOSICION]: 'Excluir de políticas de reposición'
};

// ===================================
// PRODUCTOS INCOMPLETOS (PRODUCTOS SIN PRESENTACION)
// ===================================

export const PRODUCT_INCOMPLETE_COLUMNS = {
  SKU: 0,
  PRODUCTO: 1,
  CLIENTE_USERNAME: 2,
  CATEGORIA: 3,
  SUBCATEGORIA: 4,
  TIPO_PRODUCTO: 5,
  PROVEEDOR: 6,
  TIPO_ROTACION: 7,
  FRECUENCIA_ROTACION: 8,
  NO_APLICAR_LIMITE_PICKING: 9,
  USAR_ROTACION_ESTRICTO: 10,
  CONTROL_LOTES: 11,
  CONTROL_SERIE: 12,
  CONTROL_CALIDAD: 13,
  REQUIERE_FECHA_EXPIRACION: 14,
  CONTROL_DESCRIPTIVO_1: 15,  // Columna P - Opcional segun configuracion del sistema
  CONTROL_DESCRIPTIVO_2: 16,  // Columna Q - Opcional segun configuracion del sistema
  CONTROL_DESCRIPTIVO_3: 17,  // Columna R - Opcional segun configuracion del sistema
  UNIDAD_ALMACENAMIENTO: 18
};

// Nombres legibles para headers de Productos Incompletos
export const PRODUCT_INCOMPLETE_HEADERS = {
  [PRODUCT_INCOMPLETE_COLUMNS.SKU]: 'SKU*',
  [PRODUCT_INCOMPLETE_COLUMNS.PRODUCTO]: 'Producto*',
  [PRODUCT_INCOMPLETE_COLUMNS.CLIENTE_USERNAME]: 'Cliente Username*',
  [PRODUCT_INCOMPLETE_COLUMNS.CATEGORIA]: 'Categoría*',
  [PRODUCT_INCOMPLETE_COLUMNS.SUBCATEGORIA]: 'Subcategoría',
  [PRODUCT_INCOMPLETE_COLUMNS.TIPO_PRODUCTO]: 'Tipo de Producto',
  [PRODUCT_INCOMPLETE_COLUMNS.PROVEEDOR]: 'Proveedor',
  [PRODUCT_INCOMPLETE_COLUMNS.TIPO_ROTACION]: 'Tipo de Rotación*',
  [PRODUCT_INCOMPLETE_COLUMNS.FRECUENCIA_ROTACION]: 'Frecuencia de Rotación*',
  [PRODUCT_INCOMPLETE_COLUMNS.NO_APLICAR_LIMITE_PICKING]: 'No aplicar límite de picking',
  [PRODUCT_INCOMPLETE_COLUMNS.USAR_ROTACION_ESTRICTO]: 'Usar tipo de rotacion estricto',
  [PRODUCT_INCOMPLETE_COLUMNS.CONTROL_LOTES]: 'Tiene Control por Lotes*',
  [PRODUCT_INCOMPLETE_COLUMNS.CONTROL_SERIE]: 'Tiene Control por Serie*',
  [PRODUCT_INCOMPLETE_COLUMNS.CONTROL_CALIDAD]: 'Tiene Control de Calidad*',
  [PRODUCT_INCOMPLETE_COLUMNS.REQUIERE_FECHA_EXPIRACION]: 'Requiere Fecha de Expiración*',
  [PRODUCT_INCOMPLETE_COLUMNS.CONTROL_DESCRIPTIVO_1]: 'Tiene Control por Descriptivo 1',
  [PRODUCT_INCOMPLETE_COLUMNS.CONTROL_DESCRIPTIVO_2]: 'Tiene Control por Descriptivo 2',
  [PRODUCT_INCOMPLETE_COLUMNS.CONTROL_DESCRIPTIVO_3]: 'Tiene Control por Descriptivo 3',
  [PRODUCT_INCOMPLETE_COLUMNS.UNIDAD_ALMACENAMIENTO]: 'Unidad de Almacenamiento*'
};

// ===================================
// PRODUCTOS COMBO (PRODUCT COMBOS)
// ===================================

// Columnas del Excel de importación de productos combo.
// La primera fila de cada combo trae la cabecera + su primer componente;
// las filas siguientes (con Producto vacío) agregan componentes al mismo combo.
// El Tipo/Frecuencia de Rotación del combo no se piden en el Excel: se completan
// automaticamente con los valores del primer componente al importar.
export const PRODUCT_COMBO_COLUMNS = {
  SKU: 0,
  PRODUCTO: 1,
  CLIENTE_USERNAME: 2,
  CATEGORIA: 3,
  SUBCATEGORIA: 4,
  TIPO_PRODUCTO: 5,
  SKU_PRODUCTO: 6,
  CANTIDAD_COMBO: 7
};

// Nombres legibles para headers de Productos Combo
export const PRODUCT_COMBO_HEADERS = {
  [PRODUCT_COMBO_COLUMNS.SKU]: 'SKU*',
  [PRODUCT_COMBO_COLUMNS.PRODUCTO]: 'Producto*',
  [PRODUCT_COMBO_COLUMNS.CLIENTE_USERNAME]: 'Cliente Username*',
  [PRODUCT_COMBO_COLUMNS.CATEGORIA]: 'Categoría*',
  [PRODUCT_COMBO_COLUMNS.SUBCATEGORIA]: 'Subcategoría',
  [PRODUCT_COMBO_COLUMNS.TIPO_PRODUCTO]: 'Tipo de Producto',
  [PRODUCT_COMBO_COLUMNS.SKU_PRODUCTO]: 'SKU_PRODUCTO*',
  [PRODUCT_COMBO_COLUMNS.CANTIDAD_COMBO]: 'CANTIDAD_COMBO*'
};

// ===================================
// PUNTOS DE ENTREGA (SUBCLIENTS)
// ===================================

// Columnas de Puntos de Entrega
// NOTA: La columna 11 (CLIENTE) solo aparece si el usuario es Admin.
// Si el usuario es un Cliente logueado, esta columna NO existe en el Excel.
export const SUBCLIENT_COLUMNS = {
  NOMBRE: 0,
  EMAIL: 1,
  TELEFONO: 2,
  DIRECCION: 3,
  REFERENCIA: 4,
  LOCALIDAD: 5,
  CODIGO_POSTAL: 6,
  PROVINCIA: 7,
  LATITUD: 8,
  LONGITUD: 9,
  REFERENCIA_EXTERNA: 10,
  CLIENTE: 11  // Solo si es Admin
};

// Nombres legibles para headers de Puntos de Entrega
export const SUBCLIENT_HEADERS = {
  [SUBCLIENT_COLUMNS.NOMBRE]: 'Nombre*',
  [SUBCLIENT_COLUMNS.EMAIL]: 'Email',
  [SUBCLIENT_COLUMNS.TELEFONO]: 'Teléfono',
  [SUBCLIENT_COLUMNS.DIRECCION]: 'Dirección*',
  [SUBCLIENT_COLUMNS.REFERENCIA]: 'Referencia',
  [SUBCLIENT_COLUMNS.LOCALIDAD]: 'Localidad*',
  [SUBCLIENT_COLUMNS.CODIGO_POSTAL]: 'Código Postal*',
  [SUBCLIENT_COLUMNS.PROVINCIA]: 'Provincia*',
  [SUBCLIENT_COLUMNS.LATITUD]: 'Latitud',
  [SUBCLIENT_COLUMNS.LONGITUD]: 'Longitud',
  [SUBCLIENT_COLUMNS.REFERENCIA_EXTERNA]: 'Referencia Externa',
  [SUBCLIENT_COLUMNS.CLIENTE]: 'Cliente*'  // Solo si es Admin
};

// ===================================
// REGLAS DE REPOSICION
// ===================================

// Columnas del Excel de importacion de reglas de reposicion.
// OJO: el Excel trae UNA UBICACION POR FILA. Una regla es cliente + producto + almacen +
// min/max + N ubicaciones, asi que las filas que comparten Cliente + Almacen + SKU son la
// misma regla: el modal las agrupa antes de importar y las manda en una sola llamada con
// locations_arr. El cliente es obligatorio (por username, como en productos): el SKU no es unico entre clientes.
export const REPOSICION_RULE_COLUMNS = {
  CLIENTE: 0,
  ALMACEN: 1,
  SKU: 2,
  STOCK_MIN: 3,
  STOCK_MAX: 4,
  UBICACION: 5
};

// Nombres legibles para headers de Reglas de Reposicion
export const REPOSICION_RULE_HEADERS = {
  [REPOSICION_RULE_COLUMNS.CLIENTE]: 'Cliente Username*',
  [REPOSICION_RULE_COLUMNS.ALMACEN]: 'Almacén*',
  [REPOSICION_RULE_COLUMNS.SKU]: 'SKU*',
  [REPOSICION_RULE_COLUMNS.STOCK_MIN]: 'Stock mínimo*',
  [REPOSICION_RULE_COLUMNS.STOCK_MAX]: 'Stock máximo*',
  [REPOSICION_RULE_COLUMNS.UBICACION]: 'Ubicación*'
};

// Columnas del Excel de importacion de politicas de reposicion. Una politica por fila; si ya
// existe una con el mismo Almacen + Cliente + Categoria + Subcategoria se actualiza.
// Los headers los valida el modal contra get-excel-headers-version (backend
// PoliticaReposicionExcelColumns), asi que no se repiten aca.
export const POLITICA_REPOSICION_COLUMNS = {
  ALMACEN: 0,
  CLIENTE_USERNAME: 1, // Opcional: vacio = todos los clientes
  CATEGORIA: 2,
  SUBCATEGORIA: 3, // Opcional: vacio = toda la categoria
  TIPO_UBICACION: 4,
  MIN_DAYS: 5,
  MAX_DAYS: 6,
  BACK_PERIOD_DAYS: 7, // Opcional: vacio = 180
  STOCK_MIN_DEFAULT: 8,
  STOCK_MAX_DEFAULT: 9,
  FACTOR_LLENADO: 10, // Opcional: vacio = 0,85
  UMBRAL_CAMBIO_PCT: 11, // Opcional: vacio = 15
  REDONDEAR_A_CAJA: 12, // Opcional: SI/NO, vacio = NO
  ACTIVA: 13 // Opcional: SI/NO, vacio = SI
};
